/**
 * @param {string | undefined} name Snake cased string to be converted to spaced with title Case
 * @return {string | undefined} String Without underscore and Each initial character of word capitalize
 */
export function toTitleCaseWithSpace(name: string): string | undefined {
  return name
    ?.split("_")
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(" ");
}


export const getColorForLetter = (letter: string) => {
  const colors = [
    "#F44336", "#E91E63", "#9C27B0", "#673AB7", "#3F51B5", "#2196F3", "#03A9F4", "#00BCD4",
    "#009688", "#4CAF50", "#8BC34A", "#CDDC39", "#FFC107", "#FF9800", "#FF5722"
  ];
  return colors[letter.toUpperCase().charCodeAt(0) % colors.length];
};